module.exports = __webpack_public_path__ + "img/activity_rules.324b3858.png";